import React from "react";

import R from "ramda";

import { Box, Flex, PlainImage, Link, Text } from "src/components/base";

const Callout = ({ item, ...props }) => {
  const details = R.path(["details", "details"], item);

  return (
    <Box flex={1} mx={2}>
      <Link
        to={item.url}
        px={2}
        py={2}
        color="blue"
        align="center"
        style={{ textDecoration: "none", display: 'block' }}
      >
        <Box mb={1}>
          <PlainImage
            src={item.graphic.file.url}
            height={[30, 30, 40, 50]}
            width={[30, 30, 40, 50]}
            alt={`A graphic representing the ${item.title} page`}
          />
        </Box>
        <Text
          upper={true}
          fontWeight="bold"
          underline="none"
          align="center"
        >
          {item.title}
        </Text>
      </Link>
      {details ? (
        <Text fontWeight="medium" color="text" align="center">
          {details}
        </Text>
      ) : null}
    </Box>
  );
};

export default Callout;

export const calloutFragment = graphql`
  fragment Callout on ContentfulCallout {
    id
    title
    url
    details {
      details
    }
    graphic {
      file {
        url
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/ItemGroup/Callout.js